/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaginationMetaDto
 */
export interface PaginationMetaDto {
    /**
     * 
     * @type {number}
     * @memberof PaginationMetaDto
     */
    totalItems: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetaDto
     */
    currentPage: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetaDto
     */
    itemCount: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetaDto
     */
    itemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationMetaDto
     */
    totalPages: number;
}

/**
 * Check if a given object implements the PaginationMetaDto interface.
 */
export function instanceOfPaginationMetaDto(value: object): value is PaginationMetaDto {
    if (!('totalItems' in value) || value['totalItems'] === undefined) return false;
    if (!('currentPage' in value) || value['currentPage'] === undefined) return false;
    if (!('itemCount' in value) || value['itemCount'] === undefined) return false;
    if (!('itemsPerPage' in value) || value['itemsPerPage'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PaginationMetaDtoFromJSON(json: any): PaginationMetaDto {
    return PaginationMetaDtoFromJSONTyped(json, false);
}

export function PaginationMetaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginationMetaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalItems': json['totalItems'],
        'currentPage': json['currentPage'],
        'itemCount': json['itemCount'],
        'itemsPerPage': json['itemsPerPage'],
        'totalPages': json['totalPages'],
    };
}

export function PaginationMetaDtoToJSON(json: any): PaginationMetaDto {
    return PaginationMetaDtoToJSONTyped(json, false);
}

export function PaginationMetaDtoToJSONTyped(value?: PaginationMetaDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalItems': value['totalItems'],
        'currentPage': value['currentPage'],
        'itemCount': value['itemCount'],
        'itemsPerPage': value['itemsPerPage'],
        'totalPages': value['totalPages'],
    };
}

